/**
 * Common/ServiceLevels、Common/MaintenanceCycles 的 mock 種子(票 27)。
 *
 * **抄 SIT 2026-09-13 smoke 實測值**(docs/api/smoke-SIT-20260913.md),不是照文件猜:
 * 兩支都回 `[{ value:int, text }]`,與 OperatingEnvironments 同型。
 * 前端在票 18 切真後端前,合約列仍存 text(如 "7*24")當 sla/cycle 值;value 是主檔 id。
 * 這份也是 `scripts/smoke-backend.js` 期望表的對照(helpers/__tests__/smokeContractLookups.test.js 守著)。
 */
export const SERVICE_LEVELS = [
  { value: 1, text: "5*8" },
  { value: 2, text: "5*10" },
  { value: 3, text: "7*10" },
  { value: 4, text: "7*24" },
];

export const MAINTENANCE_CYCLES = [
  { value: 1, text: "月維護" },
  { value: 2, text: "季維護" },
  { value: 3, text: "半年維護" },
  { value: 4, text: "年維護" },
];
